import * as React from "react";

import FinishCardContent from "./FinishCardContent";

type TFinishCardProps = {
  quizUrl?: string;
  quizQuestionCount?: number;
  todoUrl?: string;
  todoAction?: string;
  caseSummaryUrl: string;
  title: string;
  timeOnCase: string;
};

const FinishCard = ({
  quizUrl,
  quizQuestionCount,
  todoUrl,
  todoAction,
  caseSummaryUrl,
  title,
  timeOnCase,
}: TFinishCardProps) => (
  <div className="finish-card">
    <FinishCardContent
      quizUrl={quizUrl}
      quizQuestionCount={quizQuestionCount}
      todoUrl={todoUrl}
      todoAction={todoAction}
      caseSummaryUrl={caseSummaryUrl}
      title={title}
      timeOnCase={timeOnCase}
      showQuestionIcon={true}
      showSummaryIcon={true}
      showWellDoneText
      onSummaryClick={() => {
        if (typeof window !== 'undefined' && window.localStorage) {
          localStorage.removeItem("showModal");
        }
      }}
    />
  </div>
);

export default React.memo(FinishCard);
